import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33bf307e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-img" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "desc" }
const _hoisted_5 = { class: "select" }

import { Tabs, Tab } from 'vant'
import { inject, Ref, ref } from 'vue'
import Img from './img.vue';
interface IProps {
    tabTitle?: string;
    title?: string;
    img?: string;
    desc?: string;
    list?: Array<any>,
    index?: number,
}

export default /*#__PURE__*/_defineComponent({
  props: {
    tabTitle: null,
    title: { default: '' },
    img: null,
    desc: null,
    list: null,
    index: null
  },
  emits: ["updateSubIndex"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'updateSubIndex', index: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tabTitle?: string, title: string, img?: string, desc?: string, list?: Array<any>, index?: number }



const moneyList = inject<Ref<[]>>('moneyList');

const name = ref(props.list ? props.list[0].name : props.title)
const showImg = ref(props.list ? props.list[0].showPicture : '')
const selectOptions = ref([]);
if (props.list) {
    props.list.forEach(item => {
        // @ts-ignore
        selectOptions.value.push(item.partType == 'carColor' ? item.colorOptions : item.showPicture)
    })
}
const price = ref(props.list ? props.list[0].price : '')
// const price = ref('')
const updateIndex = (index: number) => {
    if (props.list) {
        price.value = props.list[index].price
        name.value = props.list[index].name
        showImg.value = props.list[index].showPicture
        // console.log(props.index)
        // @ts-ignore
        moneyList!.value[props.index ?? 0] = props.list[index].price
        emits('updateSubIndex', index)
    }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tab), {
    class: "my-tab",
    title: __props.list ? __props.list[0].partTypeName : __props.tabTitle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: showImg.value ?? __props.img
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(name.value), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(price.value == '0' ? '价格已包含' : '+¥' + price.value), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Img, {
          list: selectOptions.value,
          onUpdateIndex: updateIndex
        }, null, 8, ["list"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})